import type { TFunction } from 'i18next';
import { ViewBy } from '../../../../store/financials-store/financials-store.type';

type DataPoint = {
  date: string;
  [key: string]: string | number;
};

/**
 * Build the ViewBy → display label map keyed against the caller's current
 * translation function so org-level text_config overrides propagate (a
 * module-level constant initialized with i18n.t() would freeze the labels at
 * import time and never see the override).
 *
 * @param {TFunction} t - Translation function from `useTranslation()`
 * @returns {Record<ViewBy, string>} Map from ViewBy enum value to localized label
 */
const getViewByLabels = (t: TFunction): Record<ViewBy, string> => ({
  [ViewBy.Tasks]: t('common.work_units'),
  [ViewBy.Points]: t('common.estimation'),
  // Below we use the base labels and append "in <currencyCode>" dynamically later
  [ViewBy.TasksInUSD]: t('common.work_units'),
  [ViewBy.PointsInUSD]: t('common.estimation'),
});

export { getViewByLabels };
export type { DataPoint };
